import React, { useState, useRef, Component, useEffect } from "react";
import useStyles from "./styles";

// MUI Components
import {
  Grid,
  Toolbar,
  Button,
  Typography,
  IconButton,
  ListItem,
  ListItemText,
  TextField,
  Divider,
} from "@material-ui/core";
import api from "../../Axios/api";

//importing files
import vendorImg1 from "../../assets/images/FooterImages/1-manu_default-removebg-preview.png";
import vendorImg2 from "../../assets/images/FooterImages/4-manu_default-removebg-preview.png";
import vendorImg3 from "../../assets/images/FooterImages/6-manu_default-removebg-preview.png";

import {
  Switch as SwitchRouter,
  withRouter,
  Link,
} from "react-router-dom";

//Icons
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";

//social icons
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import PinterestIcon from "@material-ui/icons/Pinterest";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";


const Footer = () => {
  const classes = useStyles();
  const [vendors, setVendors] = useState([])

  //for ref of scrolling
  const ref = useRef(null);

  //for scrolling vendor logos
  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  useEffect(() => {
    api
      .get(`/buyer/vendors`, {}, { Headers: {} })
      .then((res) => {
        setVendors(res.data.data.vendors);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );
  }, []);

  return (
    <div>
      <Grid container className={classes.footerBar} position="static">
        <div className={classes.navDealProductsBtnBox}>
          <Button
            onClick={() => scroll(-230)}
            padding={0}
            variant="contained"
            marginRight={10}
            style={{
              padding: "0",
              minWidth: "fit-content",
              // margin:'auto',
              // position:'sticky',
              // marginRight:0
            }}
          >
            <ChevronLeftRoundedIcon />
          </Button>

          <Button
            onClick={() => scroll(230)}
            padding={0}
            margin={0}
            variant="contained"
            style={{
              padding: "0",
              minWidth: "fit-content",
              marginLeft: 14,
            }}
          >
            <ChevronRightOutlinedIcon />
          </Button>
        </div>

        {/* FOR RENDERING VENDOR LOGOS CAROUSEL */}
        <div ref={ref} className={classes.vendorLogoMainContainer}>
          {vendors.map((item) =>
            React.cloneElement(
              <div className={classes.vendorLogoBox}>
                {/* <Link> */}
                  <img className={classes.vendorLogoImg} src={item.logo}></img>
                {/* </Link> */}
              </div>,
              {
                key: item._id,
              }
            )
          )}
        </div>
        <Divider style={{ backgroundColor: "#e1e1e1", height: "0.5px" }} />

        {/* INFO AND LINKS SECTION */}
        <Grid container className={classes.FooterLinksMainGrid} lg={12}>
          <Grid lg={3} md={6} sm={12}>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Customer Care
            </Typography>
            {[
              {text:"Help Center", route:"/contact"},
              {text: "How To Buy", route:"/aboutus"},
              {text: "DigiMart Shop", route:"/products?mainCategoryName=All Categories"},
              {text: "Contact us", route:"/contact"},
              {text:"Deals", route:`/products?mainCategoryName=All Categories&productsFilter=onSale`},
            ].map((value) =>
              React.cloneElement(
                <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }}>
                  <Link className={classes.LinkOfFooter} to={value.route}>
                    <ListItemText
                      style={{
                        marginLeft: 0,
                      }}
                      secondary={value.text}
                    />
                  </Link>
                </ListItem>,
                {
                  key: value,
                }
              )
            )}

            <Typography
              variant="h6"
              style={{ fontWeight: "bold", marginTop: 12 }}
            >
              Make money with us
            </Typography>
            <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }} >
                  
                    <ListItemText
                    onClick={()=>window.location.href = "https://digimart-seller.netlify.app/seller/register"}
                    className={classes.LinkOfFooter}
                      style={{
                        marginLeft: 0,
                      }}
                      secondary={"Seller signup"}
                    />
              </ListItem>
            {[
            {text: "How To Sell", link:"/aboutus"}].map((value) =>
              React.cloneElement(
                <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }}>
                  <Link className={classes.LinkOfFooter} to={value.link}>
                    <ListItemText
                      style={{
                        marginLeft: 0,
                      }}
                      secondary={value.text}
                    />
                  </Link>
                </ListItem>,
                {
                  key: value,
                }
              )
            )}
          </Grid>

          <Grid lg={2} md={6} sm={12} xs={12}>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold" }}
            >
              Digi-Mart
            </Typography>
            {[
              {text:"Help Center", link:"/contact"},
              {text:"How To Buy", link: "/aboutus"},
              {text:"DigiMart Shop", link: "/buyer/products"},
              {text:"Deals", link:`/products?mainCategoryName=All Categories&productsFilter=onSale`},
              {text:"Sale Offers",link:`/products?mainCategoryName=All Categories&productsFilter=onSale`},
              {text:"All Products", link: "/products?mainCategoryName=All Categories"},
              {text:"Report a problem",link:"/reportSystemProblem"},
            ].map((value) =>
              React.cloneElement(
                <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }}>
                  <Link className={classes.LinkOfFooter} to={value.link}>
                    <ListItemText
                      style={{
                        marginLeft: 0,
                      }}
                      secondary={value.text}
                    />
                  </Link>
                </ListItem>,
                {
                  key: value,
                }
              )
            )}
          </Grid>

          <Grid lg={2} md={6} sm={12}>
            <Typography
              ///className={classes.HeaderLinksHeadingText}
              variant="h6"
              style={{ fontWeight: "bold" }}
            >
              My Account
            </Typography>
            {[
              {text:"Account", link:"/account"},
              {text:"Orders History", link:"/orders"},
              {text: "Reviews", link:"/reviews"},
              {text:"Cart", link:"/cart"},
              {text:"Wishlist", link:"/wishlist"},
              {text:"Subscribed Stores", link:"/subscribed/stores"},
              {text:"Edit Profile",link:"/settings"},
            ].map((value) =>
              React.cloneElement(
                <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }}>
                  <Link className={classes.LinkOfFooter} to={value.link}>
                    <ListItemText
                      style={{
                        marginLeft: 0,
                      }}
                      secondary={value.text}
                    />
                  </Link>
                </ListItem>,
                {
                  key: value,
                }
              )
            )}
          </Grid>

          <Grid lg={5} md={6} sm={12}>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold" }}
            >
              Newsletter
            </Typography>
            <ListItem style={{ paddingLeft: 0, paddingBottom: 0 }}>
              <ListItemText
                style={{
                  marginLeft: 0,
                }}
                secondary={
                  "You may unsubscribe at any moment. For that purpose, please find our contact info in the legal notice."
                }
              />
            </ListItem>
            <div style={{ marginTop: 12 }}>
              <TextField
                id="outlined-basic"
                label="Your Email"
                variant="outlined"
                className={classes.newsletterInput}
              />
              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                className={classes.newsletterBtn}
              >
                <Typography
                  variant="h6"
                  style={{ fontWeight: "bold", letterSpacing: 1 }}
                >
                  Subscribe
                </Typography>
              </Button>
            </div>

            <Typography
              variant="h6"
              style={{ fontWeight: "bold", marginTop: 25 }}
            >
              Follow us
            </Typography>
            <div className={classes.Icons}>
              <IconButton style={{ padding: 3 }}>
                <FacebookIcon />
              </IconButton>
              <IconButton>
                <InstagramIcon />
              </IconButton>
              <IconButton>
                <PinterestIcon />
              </IconButton>
              <IconButton>
                <TwitterIcon />
              </IconButton>
              <IconButton>
                <YouTubeIcon />
              </IconButton>
            </div>
          </Grid>
        </Grid>

        <Divider style={{ backgroundColor: "#e1e1e1", height: "0.5px" }} />
        <Toolbar style={{ paddingLeft: 0 }}>
          <Typography
            style={{ paddingLeft: 0, color: "rgba(0, 0, 0, 0.54)" }}
            variant="body1"
            color="secondary"
          >
            Copyright © 2021 - DigiMart. All rights reserved.
          </Typography>
        </Toolbar>
      </Grid>
    </div>
  );
};

export default withRouter(Footer);
